import React, { useState, useEffect, useRef } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { Card, Button, Row, Col, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Modal, Input, Empty } from 'antd';
import { PrinterOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { getInfomationAccountFromToken, formatDateTimeWithoutHour } from '@app/utils/helper';
import { Get, Post, Put, DeleteSingle } from '@app/utils/httpProvider';
import './NhanVien.scss';
import {
    NHAN_VIEN_API,
    DON_VI_API,
    ACCOUNT_API,
    QUA_TRINH_DAO_TAO_API,
    NGOAI_NGU_API,
    BAI_BAO_API,
    DE_TAI_NHAN_VIEN_API,
    SANG_CHE_API,
    GIAI_THUONG_API,
    SACH_API,
    HUONG_DAN_HOC_VIEN_API,
    GIAI_THUONG_DAO_TAO_API,
    BaseGatewayImage
} from '@app/utils/apiUrl';

import {
    GIOI_TINH,
    HOC_VI,
    CHUC_DANH_KH,
    trangThaiPheDuyetValue
} from '@app/utils/define';

import {
    DaoTaoModal,
    NgoaiNguModal,
    BaiBaoModal,
    DeTaiModal,
    SangCheModal,
    GiaiThuongModal,
    SachModal,
    HuongDanModal,
    GiaiThuongDaoTaoModal
} from './HoSoModals';

// Subcomponents
import LecturerSearch from './components/LecturerSearch';
import ProfileSidebar from './components/ProfileSidebar';
import EducationAndLanguage from './components/EducationAndLanguage';
import AchievementTabs from './components/AchievementTabs';
import PrintLayoutV1 from './components/PrintLayoutV1';
import PrintLayoutV2 from './components/PrintLayoutV2';
import ResearchTabs from '@app/components/ResearchTabs';

const HoSoDetail = ({ 
    nhanVienIdProp = null, 
    onlyEducationAndLanguage = false, 
    hideEducationAndLanguage = false, 
    onRefresh = null, 
    refreshTrigger = 0 
}) => {
    const { id: paramId } = useParams();
    const history = useHistory();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const activeTab = query.get('tab') || 'baibao';

    // Group sub-tabs
    const researchTabs = ['baibao', 'detai', 'sangche', 'giaithuong', 'sach'];
    const trainingTabs = ['huongdan', 'giaithuongdao-tao'];
    
    let mainTab = 'nghiencuu';
    let subTab = '';
    
    if (researchTabs.includes(activeTab)) {
        mainTab = 'nghiencuu';
        subTab = activeTab;
    } else if (trainingTabs.includes(activeTab)) {
        mainTab = 'daotao';
        subTab = activeTab;
    }

    const handleMainTabSelect = (key) => {
        if (key === 'nghiencuu') {
            history.push(`${location.pathname}?tab=baibao`);
        } else if (key === 'daotao') {
            history.push(`${location.pathname}?tab=huongdan`);
        }
    };

    const handleSubTabSelect = (key) => {
        history.push(`${location.pathname}?tab=${key}`);
    };

    const currentUser = getInfomationAccountFromToken();
    const isAdmin = currentUser?.role?.toLowerCase().includes('admin') || currentUser?.role?.toLowerCase().includes('publisher') || currentUser?.role?.toLowerCase().includes('manager');

    const isMounted = useRef(true);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    // State quản lý tải dữ liệu
    const [loading, setLoading] = useState(true);
    const [hoSo, setHoSo] = useState(null);
    const [donVis, setDonVis] = useState([]);
    const [isExporting, setIsExporting] = useState(false);
    
    const pageFromQuery = parseInt(query.get('page')) || 1;

    // State cho Admin: danh sách giảng viên
    const [lecturers, setLecturers] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [filterDonVi, setFilterDonVi] = useState([]);
    const [lecturersPageIndex, setLecturersPageIndex] = useState(pageFromQuery);
    const [lecturersPageSize] = useState(10);
    const [lecturersTotalItems, setLecturersTotalItems] = useState(0);

    // Advanced search states
    const [filterHoTen, setFilterHoTen] = useState('');
    const [filterUsernameOrEmail, setFilterUsernameOrEmail] = useState('');
    const [filterHocVi, setFilterHocVi] = useState('');
    const [filterChucDanh, setFilterChucDanh] = useState('');
    const [filterSoCCCD, setFilterSoCCCD] = useState('');
    const [filterThanhTich, setFilterThanhTich] = useState('');
    const [filterTuNam, setFilterTuNam] = useState('');
    const [filterDenNam, setFilterDenNam] = useState('');
    const [isAdvancedOpen, setIsAdvancedOpen] = useState(false);

    // State quản lý Modals
    const [activeModal, setActiveModal] = useState(null); // 'PERSONAL', 'DAOTAO', 'NGOAINGU', 'BAIBAO', etc.
    const [selectedItem, setSelectedItem] = useState({}); // Dữ liệu dòng đang sửa
    const [rejectVisible, setRejectVisible] = useState(false);
    const [rejectReason, setRejectReason] = useState('');
    const [rejectTarget, setRejectTarget] = useState(null); // { type, id }
    const [printVersion, setPrintVersion] = useState('v1');

    useEffect(() => {
        Get(DON_VI_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000 })
            .then(res => {
                if (isMounted.current && res && res.data) {
                    const checkActive = (item) => {
                        if (!item) return false;
                        const val = item.isActive;
                        if (val === undefined || val === null) return false;
                        const str = String(val).trim().toLowerCase();
                        return str !== 'false' && str !== '0' && str !== 'null' && str !== 'undefined';
                    };
                    setDonVis(res.data.filter(checkActive));
                }
            }).catch(e => console.error(e));
    }, []);

    const prevNhanVienIdRef = useRef(null);

    useEffect(() => {
        const targetNhanVienId = nhanVienIdProp || paramId;
        const isIdChanged = prevNhanVienIdRef.current !== targetNhanVienId;
        prevNhanVienIdRef.current = targetNhanVienId;
        
        loadProfileData(!isIdChanged);
    }, [paramId, nhanVienIdProp, refreshTrigger]);

    useEffect(() => {
        if (loading || !hoSo) return;
        
        const autoPrint = new URLSearchParams(location.search).get('print');
        if (autoPrint === 'v2') {
            if (isMounted.current) setPrintVersion('v2');
            const timer = setTimeout(() => {
                window.print();
            }, 600);
            return () => clearTimeout(timer);
        } else if (autoPrint === 'v1') {
            if (isMounted.current) setPrintVersion('v1');
            const timer = setTimeout(() => {
                window.print();
            }, 600);
            return () => clearTimeout(timer);
        }
    }, [location.search, loading, hoSo]);

    const triggerReload = () => {
        if (onRefresh) {
            onRefresh();
        } else {
            loadProfileData(true);
        }
    };

    const loadProfileData = async (isSilent = false) => {
        if (!isMounted.current) return;
        
        let targetNhanVienId = nhanVienIdProp || paramId;
        const shouldShowLoading = !isSilent || !hoSo || (hoSo && targetNhanVienId && String(hoSo.nhanVien?.id) !== String(targetNhanVienId));

        if (shouldShowLoading) {
            setLoading(true);
        }
        try {
            // Ưu tiên prop khi được nhúng từ NhanVienInput
            let targetNhanVienId = nhanVienIdProp || paramId;
            
            if (!targetNhanVienId) {
                if (isMounted.current) setHoSo(null);
                // Nếu không có paramId trên url, kiểm tra xem user hiện tại là ai
                if (isAdmin) {
                    // Admin chưa chọn ai, tải danh sách nhân viên trước
                    await loadLecturersList();
                    if (isMounted.current) setLoading(false);
                    return;
                }

                const fullAccount = await Get(ACCOUNT_API.GET_BY_ID_ACCOUNT, currentUser.id);
                if (fullAccount && fullAccount.nhanVienId) {
                    targetNhanVienId = fullAccount.nhanVienId;
                } else {
                    // Chỉ redirect khi không phải embedded component
                    if (!nhanVienIdProp) history.push('/nhan-vien');
                    if (isMounted.current) setLoading(false);
                    return;
                }
            }

            if (targetNhanVienId) {
                // Tải trọn gói hồ sơ CV từ API
                const res = await Get(NHAN_VIEN_API.GET_HOSO_CV, targetNhanVienId);
                if (res && !res.error) {
                    try {
                        // Lấy thêm thông tin chi tiết nhân viên để bù đắp các trường giới thiệu bản thân bị thiếu
                        const detailRes = await Get(NHAN_VIEN_API.GET_BY_ID, targetNhanVienId);
                        if (isMounted.current && detailRes && !detailRes.error) {
                            res.nhanVien = { ...res.nhanVien, ...detailRes };
                        }
                    } catch (e) {
                        console.error("Lỗi lấy thông tin chi tiết nhân viên:", e);
                    }
                    if (isMounted.current) setHoSo(res);
                } else {
                    toast.error("Không tải được thông tin lý lịch");
                }
            }
        } catch (error) {
            console.error("Lỗi khi tải hồ sơ:", error);
            toast.error("Có lỗi xảy ra khi kết nối hệ thống");
        }
        if (isMounted.current) setLoading(false);
    };

    const loadLecturersList = async (page = null, customFilters = {}) => {
        try {
            const targetPage = page !== null ? page : lecturersPageIndex;
            const params = {
                PageIndex: targetPage,
                PageSize: lecturersPageSize,
                Keyword: searchKeyword,
                HoTen: customFilters.hasOwnProperty('HoTen') ? customFilters.HoTen : filterHoTen,
                UsernameOrEmail: customFilters.hasOwnProperty('UsernameOrEmail') ? customFilters.UsernameOrEmail : filterUsernameOrEmail,
                HocVi: customFilters.hasOwnProperty('HocVi') ? customFilters.HocVi : filterHocVi,
                ChucDanhKH: customFilters.hasOwnProperty('ChucDanhKH') ? customFilters.ChucDanhKH : filterChucDanh,
                SoCCCD: customFilters.hasOwnProperty('SoCCCD') ? customFilters.SoCCCD : filterSoCCCD,
                TrangThaiThanhTich: customFilters.hasOwnProperty('TrangThaiThanhTich') ? customFilters.TrangThaiThanhTich : filterThanhTich,
                TuNam: customFilters.hasOwnProperty('TuNam') ? customFilters.TuNam : filterTuNam,
                DenNam: customFilters.hasOwnProperty('DenNam') ? customFilters.DenNam : filterDenNam
            };
            const donViIds = customFilters.hasOwnProperty('DonViIds') ? customFilters.DonViIds : filterDonVi;
            if (donViIds && donViIds.length > 0) {
                params.DonViIds = donViIds;
            }

            // Clean up empty, null, or undefined parameters to prevent 400 Bad Request
            // and ensure clean resets fetch all data from backend
            const cleanParams = {};
            Object.keys(params).forEach(key => {
                const val = params[key];
                if (val !== null && val !== undefined && val !== '') {
                    cleanParams[key] = val;
                }
            });

            const res = await Get(NHAN_VIEN_API.GET_PAGING, null, cleanParams);
            if (isMounted.current && res && res.data) {
                setLecturers(res.data);
                setLecturersTotalItems(res.totalRecords || 0);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handlePageChange = (num) => {
        setLecturersPageIndex(num);
        const params = new URLSearchParams(location.search);
        params.set('page', num);
        history.push(`${location.pathname}?${params.toString()}`);
    };

    useEffect(() => {
        if (isAdmin && !paramId) {
            loadLecturersList();
        }
    }, [lecturersPageIndex]);

    useEffect(() => {
        const pageFromQuery = parseInt(new URLSearchParams(location.search).get('page')) || 1;
        setLecturersPageIndex(pageFromQuery);
    }, [location.search]);

    // =========================================================================
    // XỬ LÝ DUYỆT / TỪ CHỐI (ADMIN ONLY)
    // =========================================================================
    const handleApprove = async (type, id) => {
        try {
            let api = null;
            if (type === 'BaiBao') api = BAI_BAO_API.APPROVE;
            if (type === 'DeTai') api = DE_TAI_NHAN_VIEN_API.APPROVE;
            if (type === 'SangChe') api = SANG_CHE_API.APPROVE;
            if (type === 'GiaiThuong') api = GIAI_THUONG_API.APPROVE;
            if (type === 'Sach') api = SACH_API.APPROVE;
            if (type === 'HuongDanHocVien') api = HUONG_DAN_HOC_VIEN_API.APPROVE;
            if (type === 'GiaiThuongDaoTao') api = GIAI_THUONG_DAO_TAO_API.APPROVE;

            if (api) {
                const res = await Put(api, id);
                if (res) {
                    toast.success("Phê duyệt thành công!");
                    triggerReload();
                }
            }
        } catch (e) {
            toast.error("Phê duyệt thất bại");
        }
    };

    const handleRevoke = async (type, id) => {
        try {
            let api = null;
            if (type === 'BaiBao') api = BAI_BAO_API.REVOKE;
            if (type === 'DeTai') api = DE_TAI_NHAN_VIEN_API.REVOKE;
            if (type === 'SangChe') api = SANG_CHE_API.REVOKE;
            if (type === 'GiaiThuong') api = GIAI_THUONG_API.REVOKE;
            if (type === 'Sach') api = SACH_API.REVOKE;
            if (type === 'HuongDanHocVien') api = HUONG_DAN_HOC_VIEN_API.REVOKE;
            if (type === 'GiaiThuongDaoTao') api = GIAI_THUONG_DAO_TAO_API.REVOKE;

            if (api) {
                const res = await Put(api, id);
                if (res) {
                    toast.success("Thu hồi phê duyệt thành công!");
                    triggerReload();
                }
            }
        } catch (e) {
            toast.error("Thu hồi phê duyệt thất bại");
        }
    };

    const openRejectModal = (type, id) => {
        setRejectTarget({ type, id });
        setRejectReason('');
        setRejectVisible(true);
    };

    const handleRejectSubmit = async () => {
        if (!rejectReason.trim()) {
            toast.warning("Vui lòng nhập lý do từ chối");
            return;
        }
        try {
            let api = null;
            const type = rejectTarget.type;
            const id = rejectTarget.id;

            if (type === 'BaiBao') api = BAI_BAO_API.REJECT;
            if (type === 'DeTai') api = DE_TAI_NHAN_VIEN_API.REJECT;
            if (type === 'SangChe') api = SANG_CHE_API.REJECT;
            if (type === 'GiaiThuong') api = GIAI_THUONG_API.REJECT;
            if (type === 'Sach') api = SACH_API.REJECT;
            if (type === 'HuongDanHocVien') api = HUONG_DAN_HOC_VIEN_API.REJECT;
            if (type === 'GiaiThuongDaoTao') api = GIAI_THUONG_DAO_TAO_API.REJECT;

            if (api) {
                const res = await Put(api, id, { LyDoTuChoi: rejectReason });
                if (res) {
                    toast.success("Đã từ chối bản ghi thành công!");
                    if (isMounted.current) {
                        setRejectVisible(false);
                        triggerReload();
                    }
                }
            }
        } catch (e) {
            toast.error("Thao tác thất bại");
        }
    };

    const handleExportExcel = async () => {
        setIsExporting(true);
        try {
            // Tải toàn bộ danh sách giảng viên khớp với bộ lọc tìm kiếm hiện tại
            const params = {
                PageIndex: 1,
                PageSize: lecturersTotalItems || 1000,
                Keyword: searchKeyword,
                HoTen: filterHoTen,
                UsernameOrEmail: filterUsernameOrEmail,
                HocVi: filterHocVi,
                ChucDanhKH: filterChucDanh,
                SoCCCD: filterSoCCCD,
                TrangThaiThanhTich: filterThanhTich,
                TuNam: filterTuNam,
                DenNam: filterDenNam
            };
            if (filterDonVi && filterDonVi.length > 0) {
                params.DonViIds = filterDonVi;
            }

            // Dọn dẹp các trường trống/null/undefined
            const cleanParams = {};
            Object.keys(params).forEach(key => {
                const val = params[key];
                if (val !== null && val !== undefined && val !== '') {
                    cleanParams[key] = val;
                }
            });

            const res = await Get(NHAN_VIEN_API.GET_PAGING, null, cleanParams);
            if (!res || !res.data || res.data.length === 0) {
                toast.warning("Không có dữ liệu để xuất Excel!");
                return;
            }

            const allLecturers = res.data;

            // Tạo bảng HTML ảo để xuất dữ liệu sạch đẹp
            let tableHtml = `
<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
<head>
<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
<style>
  br { mso-data-placement: same-cell; }
  table { border-collapse: collapse; font-family: Calibri, "Segoe UI", Arial, sans-serif; font-size: 11pt; }
  th { background-color: #2e7d32; color: white; font-weight: bold; border: 0.5pt solid #a0a0a0; text-align: center; vertical-align: middle; padding: 8px; }
  td { border: 0.5pt solid #a0a0a0; padding: 6px; vertical-align: middle; }
  .text-center { text-align: center; }
  .text-left { text-align: left; }
  .text-right { text-align: right; }
  .txt { mso-number-format: "\\@"; }
</style>
</head>
<body>
<table border="1">
    <thead>
        <tr>
            <th rowspan="2">TT</th>
            <th rowspan="2">ID</th>
            <th rowspan="2">Username</th>
            <th rowspan="2">Họ và tên</th>
            <th rowspan="2">Ngày/tháng/năm sinh</th>
            <th rowspan="2">Giới tính</th>
            <th rowspan="2">Số điện thoại</th>
            <th rowspan="2">Email</th>
            <th rowspan="2">Số căn cước công dân</th>
            <th rowspan="2">Tài khoản ngân hàng</th>
            <th rowspan="2">Mở tại ngân hàng</th>
            <th rowspan="2">Mã số thuế</th>
            <th rowspan="2">Trình độ đào tạo (TS, TSKH)</th>
            <th rowspan="2">Năm được cấp bằng TS, TSKH</th>
            <th rowspan="2">Nơi cấp bằng TS, TSKH</th>
            <th rowspan="2">Chức danh GS/PGS</th>
            <th rowspan="2">Năm bổ nhiệm GS/PGS</th>
            <th rowspan="2">Nơi bổ nhiệm GS/PGS</th>
            <th rowspan="2">Chức vụ</th>
            <th rowspan="2">Đơn vị công tác</th>
            <th rowspan="2">Các thông tin về chỉ số định danh ORCID, hồ sơ Google scholar, H-index, số lượt trích dẫn (nếu có)</th>
            <th colspan="6">Hoạt động nghiên cứu</th>
            <th colspan="3">Hoạt động đào tạo</th>
        </tr>
        <tr>
            <th>Công bố quốc tế</th>
            <th>Công bố trong nước</th>
            <th>Nhiệm vụ KHCN</th>
            <th>Sáng chế, GPHI</th>
            <th>Giải thưởng về KHCN</th>
            <th>Sách</th>
            <th>Hướng dẫn NCS</th>
            <th>Hướng dẫn HV</th>
            <th>Giải thưởng về đào tạo</th>
        </tr>
    </thead>
    <tbody>
`;

            allLecturers.forEach((l, idx) => {
                const idVal = l.maNhanVien || '';
                const usernameVal = l.username || '';
                const hoTenVal = l.hoTen || '';
                const ngaySinhStr = l.ngaySinh && typeof l.ngaySinh === 'string' && !l.ngaySinh.startsWith('0001') ? formatDateTimeWithoutHour(l.ngaySinh) : '';
                const gioiTinhText = GIOI_TINH.find(o => o.value === l.gioiTinh)?.label || '';
                const dienThoaiVal = l.dienThoaiDiDong || '';
                const emailVal = l.emailCongViec || '';
                const cccdVal = l.soCMND_CCCD || '';
                const stkVal = l.soTaiKhoan || '';
                const nganHangVal = l.nganHang || '';
                const mstVal = l.maSoThue || '';
                const hocViText = HOC_VI.find(o => o.value === l.hocViCaoNhat)?.label || '';
                const namCapBangTSVal = l.namCapBangTS || '';
                const noiCapBangTSVal = l.noiCapBangTS || '';
                const chucDanhText = CHUC_DANH_KH.find(o => o.value === l.chucDanhKHCaoNhat)?.label || '';
                const namChucDanhVal = l.namChucDanh || '';
                const noiBoNhiemVal = l.noiBoNhiemChucDanh || '';
                const chucVuVal = l.chucVu || '';
                const donViVal = l.tenDonVi || l.tenDonViTuNhap || '';
                const thongTinIdentVal = l.thongTinIdent || '';

                const cbQuocTe = l.soBaiBaoQuocTe || 0;
                const cbTrongNuoc = l.soBaiBaoTrongNuoc || 0;
                const nvKhcn = l.soDeTai || 0;
                const sangChe = l.soSangChe || 0;
                const gtKhcn = l.soGiaiThuongKhcn || 0;
                const sach = l.soSach || 0;
                const hdNcs = l.soHuongDanNcs || 0;
                const hdHv = l.soHuongDanHv || 0;
                const gtDaoTao = l.soGiaiThuongDaoTao || 0;

                tableHtml += `
        <tr>
            <td class="text-center">${idx + 1}</td>
            <td class="text-center txt">${idVal}</td>
            <td class="text-left txt">${usernameVal}</td>
            <td class="text-left">${hoTenVal}</td>
            <td class="text-center txt">${ngaySinhStr}</td>
            <td class="text-center">${gioiTinhText}</td>
            <td class="text-center txt">${dienThoaiVal}</td>
            <td class="text-left txt">${emailVal}</td>
            <td class="text-center txt">${cccdVal}</td>
            <td class="text-center txt">${stkVal}</td>
            <td class="text-left">${nganHangVal}</td>
            <td class="text-center txt">${mstVal}</td>
            <td class="text-left">${hocViText}</td>
            <td class="text-center txt">${namCapBangTSVal}</td>
            <td class="text-left">${noiCapBangTSVal}</td>
            <td class="text-left">${chucDanhText}</td>
            <td class="text-center txt">${namChucDanhVal}</td>
            <td class="text-left">${noiBoNhiemVal}</td>
            <td class="text-left">${chucVuVal}</td>
            <td class="text-left">${donViVal}</td>
            <td class="text-left">${thongTinIdentVal}</td>
            <td class="text-right">${cbQuocTe}</td>
            <td class="text-right">${cbTrongNuoc}</td>
            <td class="text-right">${nvKhcn}</td>
            <td class="text-right">${sangChe}</td>
            <td class="text-right">${gtKhcn}</td>
            <td class="text-right">${sach}</td>
            <td class="text-right">${hdNcs}</td>
            <td class="text-right">${hdHv}</td>
            <td class="text-right">${gtDaoTao}</td>
        </tr>
`;
            });

            tableHtml += `
    </tbody>
</table>
</body>
</html>
`;

            const filename = `Danh_Sach_Giang_Vien_108_${Date.now()}.xls`;
            const downloadLink = document.createElement("a");
            document.body.appendChild(downloadLink);
            
            downloadLink.href = 'data:application/vnd.ms-excel;charset=utf-8,\ufeff' + encodeURIComponent(tableHtml);
            downloadLink.download = filename;
            downloadLink.click();
            document.body.removeChild(downloadLink);
            
            toast.success("Xuất file Excel thành công toàn bộ kết quả!");
        } catch (e) {
            console.error("Lỗi xuất Excel:", e);
            toast.error("Đã xảy ra lỗi khi xuất file Excel!");
        } finally {
            if (isMounted.current) {
                setIsExporting(false);
            }
        }
    };

    // =========================================================================
    // XỬ LÝ KHỞI TẠO & CRUD THÀNH TÍCH (GIẢNG VIÊN)
    // =========================================================================
    const handleSaveItem = async (type, values) => {
        try {
            let apiAdd = null;
            let apiEdit = null;
            
            if (type === 'DaoTao') { apiAdd = QUA_TRINH_DAO_TAO_API.ADD_ITEM; apiEdit = QUA_TRINH_DAO_TAO_API.EDIT_ITEM; }
            if (type === 'NgoaiNgu') { apiAdd = NGOAI_NGU_API.ADD_ITEM; apiEdit = NGOAI_NGU_API.EDIT_ITEM; }
            if (type === 'BaiBao') { apiAdd = BAI_BAO_API.ADD_ITEM; apiEdit = BAI_BAO_API.EDIT_ITEM; }
            if (type === 'DeTai') { apiAdd = DE_TAI_NHAN_VIEN_API.ADD_ITEM; apiEdit = DE_TAI_NHAN_VIEN_API.EDIT_ITEM; }
            if (type === 'SangChe') { apiAdd = SANG_CHE_API.ADD_ITEM; apiEdit = SANG_CHE_API.EDIT_ITEM; }
            if (type === 'GiaiThuong') { apiAdd = GIAI_THUONG_API.ADD_ITEM; apiEdit = GIAI_THUONG_API.EDIT_ITEM; }
            if (type === 'Sach') { apiAdd = SACH_API.ADD_ITEM; apiEdit = SACH_API.EDIT_ITEM; }
            if (type === 'HuongDanHocVien') { apiAdd = HUONG_DAN_HOC_VIEN_API.ADD_ITEM; apiEdit = HUONG_DAN_HOC_VIEN_API.EDIT_ITEM; }
            if (type === 'GiaiThuongDaoTao') { apiAdd = GIAI_THUONG_DAO_TAO_API.ADD_ITEM; apiEdit = GIAI_THUONG_DAO_TAO_API.EDIT_ITEM; }

            const payload = {
                ...values,
                nhanVienId: hoSo.nhanVien.id
            };

            if (selectedItem.id) {
                // UPDATE
                await Put(apiEdit, selectedItem.id, payload);
                toast.success("Cập nhật thông tin thành công!");
            } else {
                // CREATE
                await Post(apiAdd, null, payload, false);
                toast.success("Khai báo thành công! Đang chờ phê duyệt.");
            }
            if (isMounted.current) {
                setActiveModal(null);
                triggerReload();
            }
        } catch (e) {
            toast.error("Không lưu được dữ liệu");
        }
    };

    const handleDeleteItem = async (type, id) => {
        Modal.confirm({
            title: 'Xác nhận xóa bản ghi?',
            content: 'Dữ liệu này sẽ bị xóa vĩnh viễn khỏi hệ thống.',
            okText: 'Xóa bỏ',
            okType: 'danger',
            cancelText: 'Hủy',
            onOk: async () => {
                try {
                    let api = null;
                    if (type === 'DaoTao') api = QUA_TRINH_DAO_TAO_API.DELETE_ITEM;
                    if (type === 'NgoaiNgu') api = NGOAI_NGU_API.DELETE_ITEM;
                    if (type === 'BaiBao') api = BAI_BAO_API.DELETE_ITEM;
                    if (type === 'DeTai') api = DE_TAI_NHAN_VIEN_API.DELETE_ITEM;
                    if (type === 'SangChe') api = SANG_CHE_API.DELETE_ITEM;
                    if (type === 'GiaiThuong') api = GIAI_THUONG_API.DELETE_ITEM;
                    if (type === 'Sach') api = SACH_API.DELETE_ITEM;
                    if (type === 'HuongDanHocVien') api = HUONG_DAN_HOC_VIEN_API.DELETE_ITEM;
                    if (type === 'GiaiThuongDaoTao') api = GIAI_THUONG_DAO_TAO_API.DELETE_ITEM;

                    await DeleteSingle(api, id);
                    toast.success("Xóa dữ liệu thành công!");
                    if (isMounted.current) {
                        triggerReload();
                    }
                } catch (e) {
                    toast.error(e.message || "Không thể xóa bản ghi đã phê duyệt!");
                }
            }
        });
    };

    const handleExecuteSearch = () => {
        const params = new URLSearchParams(location.search);
        if (params.get('page') && params.get('page') !== '1') {
            params.set('page', 1);
            history.push(`${location.pathname}?${params.toString()}`);
        } else {
            setLecturersPageIndex(1);
            loadLecturersList(1);
        }
    };

    const handleResetFilters = () => {
        setFilterHoTen('');
        setFilterUsernameOrEmail('');
        setFilterHocVi('');
        setFilterChucDanh('');
        setFilterSoCCCD('');
        setFilterThanhTich('');
        setFilterTuNam('');
        setFilterDenNam('');
        setFilterDonVi([]);
        
        setLecturersPageIndex(1);

        const params = new URLSearchParams(location.search);
        if (params.get('page')) {
            params.delete('page');
            history.push(`${location.pathname}?${params.toString()}`);
        } else {
            loadLecturersList(1, {
                HoTen: '',
                UsernameOrEmail: '',
                HocVi: '',
                ChucDanhKH: '',
                SoCCCD: '',
                TrangThaiThanhTich: '',
                TuNam: '',
                DenNam: '',
                DonViId: ''
            });
        }
    };

    const handleToggleActive = async (lecturer) => {
        Modal.confirm({
            title: `Xác nhận ${lecturer.isActive ? 'khóa' : 'mở khóa'} giảng viên?`,
            content: `Tài khoản và hồ sơ của giảng viên "${lecturer.hoTen}" sẽ bị ${lecturer.isActive ? 'khóa (tạm dừng hoạt động)' : 'mở khóa (hoạt động trở lại)'}.`,
            okText: lecturer.isActive ? 'Khóa' : 'Mở khóa',
            okType: lecturer.isActive ? 'danger' : 'primary',
            cancelText: 'Hủy',
            onOk: async () => {
                try {
                    const res = await Put(NHAN_VIEN_API.TOGGLE_ACTIVE, lecturer.id);
                    if (res && !res.error) {
                        toast.success(`${lecturer.isActive ? 'Khóa' : 'Mở khóa'} giảng viên thành công!`);
                        if (isMounted.current) {
                            loadLecturersList();
                        }
                    } else {
                        toast.error(`Thao tác thất bại!`);
                    }
                } catch (e) {
                    toast.error(`Lỗi khi thực hiện thao tác: ${e.message || e}`);
                }
            }
        });
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                <Spinner animation="border" variant="primary" />
                <span className="ml-2">Đang tải dữ liệu khoa học giảng viên...</span>
            </div>
        );
    }

    // =========================================================================
    // CASE A: ADMIN CHƯA CHỌN GIẢNG VIÊN (DANH SÁCH GIẢNG VIÊN)
    // =========================================================================
    if (isAdmin && !paramId && !nhanVienIdProp && !hoSo) {
        return (
            <>
                <LecturerSearch
                    history={history}
                    donVis={donVis}
                    lecturers={lecturers}
                    lecturersPageIndex={lecturersPageIndex}
                    lecturersPageSize={lecturersPageSize}
                    lecturersTotalItems={lecturersTotalItems}
                    filterHoTen={filterHoTen}
                    setFilterHoTen={setFilterHoTen}
                    filterUsernameOrEmail={filterUsernameOrEmail}
                    setFilterUsernameOrEmail={setFilterUsernameOrEmail}
                    filterHocVi={filterHocVi}
                    setFilterHocVi={setFilterHocVi}
                    filterChucDanh={filterChucDanh}
                    setFilterChucDanh={setFilterChucDanh}
                    filterSoCCCD={filterSoCCCD}
                    setFilterSoCCCD={setFilterSoCCCD}
                    filterThanhTich={filterThanhTich}
                    setFilterThanhTich={setFilterThanhTich}
                    filterDonVi={filterDonVi}
                    setFilterDonVi={setFilterDonVi}
                    filterTuNam={filterTuNam}
                    setFilterTuNam={setFilterTuNam}
                    filterDenNam={filterDenNam}
                    setFilterDenNam={setFilterDenNam}
                    isAdvancedOpen={isAdvancedOpen}
                    setIsAdvancedOpen={setIsAdvancedOpen}
                    handleExecuteSearch={handleExecuteSearch}
                    handleResetFilters={handleResetFilters}
                    handleExportExcel={handleExportExcel}
                    handlePageChange={handlePageChange}
                    handleToggleActive={handleToggleActive}
                    isExporting={isExporting}
                />
                <Modal
                    open={isExporting}
                    footer={null}
                    closable={false}
                    centered
                >
                    <div style={{ padding: '30px 10px', textAlign: 'center' }}>
                        <Spinner animation="border" variant="success" size="lg" className="mb-3" />
                        <h5 style={{ color: '#28a745', fontWeight: '600' }}>
                            Đang xử lý dữ liệu và xuất báo cáo Excel...
                        </h5>
                        <p className="text-muted mb-0">Vui lòng không đóng trình duyệt hoặc tải lại trang</p>
                    </div>
                </Modal>
            </>
        );
    }

    // =========================================================================
    // CASE B: LECTURER CHƯA KHỞI TẠO LÝ LỊCH
    // =========================================================================
    if (!hoSo) {
        if (!nhanVienIdProp) {
            return (
                <Card className="text-center p-5 shadow border-0">
                    <Card.Body>
                        <Empty
                            description={
                                <span className="text-muted">
                                    <h5>Hồ sơ Lý lịch Khoa học chưa được khởi tạo!</h5>
                                    <p>Bạn cần khai báo thông tin lý lịch cá nhân ban đầu để làm hồ sơ Phụ lục 02.</p>
                                </span>
                            }
                        />
                        <Button
                            variant="primary"
                            className="mt-3"
                            onClick={() => history.push('/nhan-vien')}
                        >
                            <PlusOutlined className="mr-2" />Khởi tạo Hồ sơ khoa học
                        </Button>
                    </Card.Body>
                </Card>
            );
        }
    }

    // =========================================================================
    // CASE C: HIỂN THỊ CHI TIẾT HỒ SƠ & TABS THÀNH TÍCH
    // =========================================================================
    const nhanVien = hoSo?.nhanVien || {};
    const tenDonVi = hoSo?.tenDonVi || '';
    const quaTrinhDaoTao = hoSo?.quaTrinhDaoTao || [];
    const ngoaiNgu = hoSo?.ngoaiNgu || [];
    const baiBao = hoSo?.baiBao || [];
    const deTai = hoSo?.deTai || [];
    const sangChe = hoSo?.sangChe || [];
    const giaiThuong = hoSo?.giaiThuong || [];
    const sach = hoSo?.sach || [];
    const huongDanHocVien = hoSo?.huongDanHocVien || [];
    const giaiThuongDaoTao = hoSo?.giaiThuongDaoTao || [];

    if (onlyEducationAndLanguage) {
        return (
            <div className="cv-hoso-detail-wrapper">
                <EducationAndLanguage
                    printVersion={printVersion}
                    quaTrinhDaoTao={quaTrinhDaoTao}
                    ngoaiNgu={ngoaiNgu}
                    isAdmin={isAdmin}
                    setSelectedItem={setSelectedItem}
                    setActiveModal={setActiveModal}
                    handleDeleteItem={handleDeleteItem}
                    handleApprove={handleApprove}
                    openRejectModal={openRejectModal}
                />
                
                <DaoTaoModal
                    visible={activeModal === 'DaoTao'}
                    onCancel={() => setActiveModal(null)}
                    onSubmit={(vals) => handleSaveItem('DaoTao', vals)}
                    initialValues={selectedItem}
                />

                <NgoaiNguModal
                    visible={activeModal === 'NgoaiNgu'}
                    onCancel={() => setActiveModal(null)}
                    onSubmit={(vals) => handleSaveItem('NgoaiNgu', vals)}
                    initialValues={selectedItem}
                />
            </div>
        );
    }

    const showResearchTabs = !paramId || paramId === currentUser?.nhanVienId;

    return (
        <div className="cv-hoso-detail-wrapper">
            {/* {showResearchTabs && <ResearchTabs activeKey="gioithieu" />} */}
            {!hideEducationAndLanguage && (
                <Row className="gx-4 d-print-none">
                    {/* CỘT TRÁI: THÔNG TIN LÝ LỊCH CÁ NHÂN */}
                    <Col lg={4} md={12} xs={12} className="mb-4">
                        <ProfileSidebar 
                            nhanVien={nhanVien} 
                            tenDonVi={tenDonVi} 
                            isAdmin={isAdmin}
                            onPrintV1={() => {
                                setPrintVersion('v1');
                                setTimeout(() => window.print(), 100);
                            }}
                            onPrintV2={() => {
                                setPrintVersion('v2');
                                setTimeout(() => window.print(), 100);
                            }}
                            onEdit={() => {
                                const targetId = nhanVienIdProp || paramId;
                                if (targetId && isAdmin) {
                                    history.push(`/nhan-vien/${targetId}`);
                                } else {
                                    history.push('/nhan-vien');
                                }
                            }}
                            onBackToList={() => history.push('/profile-cv')}
                        />
                    </Col>

                    {/* CỘT PHẢI: QUÁ TRÌNH ĐÀO TẠO & NGOẠI NGỮ */}
                    <Col lg={8} md={12} xs={12} className="mb-4">
                        <EducationAndLanguage
                            printVersion={printVersion}
                            quaTrinhDaoTao={quaTrinhDaoTao}
                            ngoaiNgu={ngoaiNgu}
                            isAdmin={isAdmin}
                            setSelectedItem={setSelectedItem}
                            setActiveModal={setActiveModal}
                            handleDeleteItem={handleDeleteItem}
                            handleApprove={handleApprove}
                            openRejectModal={openRejectModal}
                        />
                    </Col>
                </Row>
            )}

            {/* TAB DANH MỤC THÀNH TÍCH (PHẦN II & PHẦN III) */}
            <Card className="shadow-sm border-0 mb-4 d-print-none">
                <Card.Body className="p-0">
                    <AchievementTabs
                        activeTab={activeTab}
                        onSelectTab={handleSubTabSelect}
                        nhanVien={nhanVien}
                        baiBao={baiBao}
                        deTai={deTai}
                        sangChe={sangChe}
                        giaiThuong={giaiThuong}
                        sach={sach}
                        huongDanHocVien={huongDanHocVien}
                        giaiThuongDaoTao={giaiThuongDaoTao}
                        isAdmin={isAdmin}
                        setSelectedItem={setSelectedItem}
                        setActiveModal={setActiveModal}
                        handleDeleteItem={handleDeleteItem}
                        handleApprove={handleApprove}
                        handleRevoke={handleRevoke}
                        openRejectModal={openRejectModal}
                    />
                </Card.Body>
            </Card>

            {/* PRINTING VIEWS */}
            {printVersion === 'v1' && (
                <PrintLayoutV1
                    nhanVien={nhanVien}
                    tenDonVi={tenDonVi}
                    baiBao={baiBao}
                    deTai={deTai}
                    sangChe={sangChe}
                    giaiThuong={giaiThuong}
                    sach={sach}
                    huongDanHocVien={huongDanHocVien}
                    giaiThuongDaoTao={giaiThuongDaoTao}
                />
            )}

            {printVersion === 'v2' && (
                <PrintLayoutV2
                    nhanVien={nhanVien}
                    tenDonVi={tenDonVi}
                    quaTrinhDaoTao={quaTrinhDaoTao}
                    ngoaiNgu={ngoaiNgu}
                    baiBao={baiBao}
                    deTai={deTai}
                    sangChe={sangChe}
                    sach={sach}
                    huongDanHocVien={huongDanHocVien}
                />
            )}

            {/* MODALS CHO CÁC PHẦN CRUD THÀNH TÍCH */}
            <DaoTaoModal
                visible={activeModal === 'DaoTao'}
                onCancel={() => setActiveModal(null)}
                onSubmit={(val) => handleSaveItem('DaoTao', val)}
                initialValues={selectedItem}
            />

            <NgoaiNguModal
                visible={activeModal === 'NgoaiNgu'}
                onCancel={() => setActiveModal(null)}
                onSubmit={(val) => handleSaveItem('NgoaiNgu', val)}
                initialValues={selectedItem}
            />

            <BaiBaoModal
                visible={activeModal === 'BaiBao'}
                onCancel={() => setActiveModal(null)}
                onSubmit={(val) => handleSaveItem('BaiBao', val)}
                initialValues={selectedItem}
            />

            <DeTaiModal
                visible={activeModal === 'DeTai'}
                onCancel={() => setActiveModal(null)}
                onSubmit={(val) => handleSaveItem('DeTai', val)}
                initialValues={selectedItem}
            />

            <SangCheModal
                visible={activeModal === 'SangChe'}
                onCancel={() => setActiveModal(null)}
                onSubmit={(val) => handleSaveItem('SangChe', val)}
                initialValues={selectedItem}
            />

            <GiaiThuongModal
                visible={activeModal === 'GiaiThuong'}
                onCancel={() => setActiveModal(null)}
                onSubmit={(val) => handleSaveItem('GiaiThuong', val)}
                initialValues={selectedItem}
            />

            <SachModal
                visible={activeModal === 'Sach'}
                onCancel={() => setActiveModal(null)}
                onSubmit={(val) => handleSaveItem('Sach', val)}
                initialValues={selectedItem}
            />

            <HuongDanModal
                visible={activeModal === 'HuongDanHocVien'}
                onCancel={() => setActiveModal(null)}
                onSubmit={(val) => handleSaveItem('HuongDanHocVien', val)}
                initialValues={selectedItem}
            />

            <GiaiThuongDaoTaoModal
                visible={activeModal === 'GiaiThuongDaoTao'}
                onCancel={() => setActiveModal(null)}
                onSubmit={(val) => handleSaveItem('GiaiThuongDaoTao', val)}
                initialValues={selectedItem}
            />

            {/* MODAL ADMIN TỪ CHỐI DUYỆT CÓ NHẬP LÝ DO */}
            <Modal
                title="Lý do từ chối phê duyệt"
                open={rejectVisible}
                onCancel={() => setRejectVisible(false)}
                onOk={handleRejectSubmit}
                okText="Xác nhận từ chối"
                okType="danger"
                cancelText="Hủy"
            >
                <div className="mb-3">
                    <label className="d-block font-weight-bold mb-2">Nhập lý do từ chối duyệt thành tích này (*):</label>
                    <Input.TextArea
                        rows={3}
                        placeholder="Ví dụ: Thiếu ảnh chụp minh chứng trang xi-nhê của tạp chí..."
                        value={rejectReason}
                        onChange={(e) => setRejectReason(e.target.value)}
                    />
                </div>
            </Modal>
        </div>
    );
};

export default HoSoDetail;
